module.exports = __webpack_public_path__ + "media/images/SP-Águas-Colorido-b5272e10215aa5e42f90a4ff4a7ae224.png";